import { render } from "./QualityOverview.vue?vue&type=template&id=1227df2e&scoped=true"
import script from "./QualityOverview.vue?vue&type=script&lang=js"
export * from "./QualityOverview.vue?vue&type=script&lang=js"

import "./QualityOverview.vue?vue&type=style&index=0&id=1227df2e&lang=scss&scoped=true"
import "./QualityOverview.vue?vue&type=style&index=1&id=1227df2e&lang=scss"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1227df2e"]])

export default __exports__